/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, version: NonNullable<unknown> }} Body_Assessment_Consent_GrantedInputs */

const en_us2_body_assessment_consent_granted = /** @type {(inputs: Body_Assessment_Consent_GrantedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You agreed on ${i?.date}, to version ${i?.version} of this text.`)
};

const pt_br2_body_assessment_consent_granted = /** @type {(inputs: Body_Assessment_Consent_GrantedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você concordou em ${i?.date}, com a versão ${i?.version} deste texto.`)
};

const es_419_body_assessment_consent_granted = /** @type {(inputs: Body_Assessment_Consent_GrantedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aceptaste el ${i?.date}, la versión ${i?.version} de este texto.`)
};

const pt_pt2_body_assessment_consent_granted = /** @type {(inputs: Body_Assessment_Consent_GrantedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Concordaste em ${i?.date}, com a versão ${i?.version} deste texto.`)
};

const fr_fr2_body_assessment_consent_granted = /** @type {(inputs: Body_Assessment_Consent_GrantedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu as accepté le ${i?.date}, la version ${i?.version} de ce texte.`)
};

const de_de2_body_assessment_consent_granted = /** @type {(inputs: Body_Assessment_Consent_GrantedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du hast am ${i?.date} Version ${i?.version} dieses Texts zugestimmt.`)
};

const it_it2_body_assessment_consent_granted = /** @type {(inputs: Body_Assessment_Consent_GrantedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hai accettato il ${i?.date}, la versione ${i?.version} di questo testo.`)
};

/**
* | output |
* | --- |
* | "You agreed on {date}, to version {version} of this text." |
*
* @param {Body_Assessment_Consent_GrantedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_consent_granted = /** @type {((inputs: Body_Assessment_Consent_GrantedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Consent_GrantedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_consent_granted(inputs)
	if (locale === "es-419") return es_419_body_assessment_consent_granted(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_consent_granted(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_consent_granted(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_consent_granted(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_consent_granted(inputs)
	return en_us2_body_assessment_consent_granted(inputs)
});
export { body_assessment_consent_granted as "body-assessment.consent_granted" }